module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('section', {
    staticClass: "content"
  }, [_c('el-dialog', {
    attrs: {
      "title": "Login",
      "visible": true,
      "size": "tiny"
    }
  }, [_c('div', {
    staticClass: "account-box"
  }, [_c('el-form', {
    ref: "login",
    attrs: {
      "model": _vm.inputs,
      "label-width": "120px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.formSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputUsernameEmail"
    }
  }, [_vm._v("Username or email")]), _vm._v(" "), _c('el-input', {
    staticClass: "input-shell",
    class: {
      error: _vm.$v.inputs.email.$error
    },
    attrs: {
      "type": "text",
      "id": "inputUsernameEmail"
    },
    on: {
      "input": function($event) {
        return _vm.$v.inputs.email.$touch()
      }
    },
    model: {
      value: (_vm.inputs.email),
      callback: function($$v) {
        _vm.$set(_vm.inputs, "email", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "inputs.email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('PasswordInput', {
    staticClass: "input-shell",
    class: {
      error: _vm.$v.inputs.password.$error
    },
    attrs: {
      "autocomplete": "current-password"
    },
    on: {
      "input": function($event) {
        return _vm.$v.inputs.password.$touch()
      }
    },
    model: {
      value: (_vm.inputs.password),
      callback: function($$v) {
        _vm.$set(_vm.inputs, "password", $$v)
      },
      expression: "inputs.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group has-error"
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.serverErrors),
      expression: "!!serverErrors"
    }]
  }, [_vm._v(_vm._s(_vm.serverErrors))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn btn-primary pull-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.formSubmit
    }
  }, [_vm._v("\n            Log In\n            "), _c('DotsLoading', {
    attrs: {
      "loading": !!_vm.loginPromise
    }
  })], 1)]), _vm._v(" "), _c('a', {
    staticClass: "forgotLnk",
    attrs: {
      "href": "#"
    }
  })], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7f87b417!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 1164
// module chunks = 2